import { UsageTrackerEvent } from '@volumental/analytic';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useInputStore } from '../../../store';
import { Feedback } from '../../result/components/feedback';

interface ExitModalProps {
  closeModal: () => void;
  closeSideBar: () => void;
  show: boolean;
}

export function ExitModal({
  closeModal,
  closeSideBar,
  show,
}: ExitModalProps): JSX.Element {
  const { scanID, previousPurchaseID } = useInputStore((store) => store);
  const { t } = useTranslation();

  return (
    <Feedback
      show={show}
      onClose={closeSideBar}
      closeModal={closeModal}
      scanID={scanID}
      previousPurchaseID={previousPurchaseID}
      trackingEvent={UsageTrackerEvent.ExitScanning}
      title={t('feedbackModal.ratingTitle')}
    />
  );
}
